import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Info } from "lucide-react";
import { Input } from "@/components/ui-kit";
import { api, errorText } from "@/lib/api";
import { usePrefs } from "@/contexts/PrefsContext";

export const AboutSettings = () => {
  const { t } = usePrefs();
  const [f, setF] = useState({ text_ar: "", text_en: "", facebook: "" });
  useEffect(() => { api.get("/platform/about").then((r) => setF({ text_ar: r.data.text_ar, text_en: r.data.text_en, facebook: r.data.facebook })).catch(() => {}); }, []);
  const save = async () => {
    try { setF((await api.put("/admin/platform/about", f)).data); toast.success(t("about.saved")); } catch (e) { toast.error(errorText(e, t)); }
  };
  const area = (k: "text_ar" | "text_en", dir: string) => (
    <textarea dir={dir} value={f[k]} maxLength={3000} rows={4} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`about-${k}-input`}
      placeholder={t(k === "text_ar" ? "about.textAr" : "about.textEn")} className="w-full rounded-2xl border bg-background p-3 text-sm" />
  );
  return (
    <div data-testid="about-settings" className="rounded-3xl border bg-card p-5 space-y-3">
      <p className="font-bold flex items-center gap-2"><Info className="h-5 w-5" />{t("about.adminTitle")}</p>
      <p className="text-sm text-muted-foreground">{t("about.adminNote")}</p>
      {area("text_ar", "rtl")}
      {area("text_en", "ltr")}
      <Input dir="ltr" value={f.facebook} onChange={(e: any) => setF({ ...f, facebook: e.target.value })} placeholder="https://facebook.com/..." data-testid="about-facebook-input" className="h-10 rounded-full" />
      <button onClick={save} data-testid="about-save" className="h-10 px-5 rounded-full bg-primary text-primary-foreground text-sm font-bold active:scale-95 transition-transform">{t("common.save")}</button>
    </div>
  );
};
